import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Modal } from 'components/styled/modal'
import { H3, Body, ExternalPrimaryLink } from 'components/styled/typography'
import { mapLanguageToComponentProps } from 'i18n'
import { I18nComponentType } from 'i18n/i18n-types'
import QRCodeDownload from 'admin/components/qr-code-download'

interface ModalLinkShareProps {
  isOpen: boolean
  id: string
  onClose: () => void
  i18n: I18nComponentType
  url: string
  showQRCode?: boolean
  title?: string
  event?: { locationId: string; id: string; properties: object }
}

const StyledBody = styled(Body)`
  margin-bottom: ${({ theme }) => theme.space.s16};
`

export function ModalLinkShare({
  onClose,
  id,
  isOpen,
  i18n,
  url,
  showQRCode = false,
  title = 'share-qr-code',
  event,
}: ModalLinkShareProps) {
  return (
    <Modal
      id={id}
      isOpen={isOpen}
      onClose={onClose}
      primaryButton={{
        onClick: onClose,
        text: i18n.modalApplicationForm.close,
      }}
    >
      <H3>{i18n.modalLinkShare.title}</H3>
      <StyledBody>{i18n.modalLinkShare.info}</StyledBody>
      <ExternalPrimaryLink target="_blank" rel="noopener noreferrer" href={url}>
        {url}
      </ExternalPrimaryLink>
      {showQRCode && (
        <QRCodeDownload size={200} event={event} url={url} title={title} />
      )}
    </Modal>
  )
}

export default connect(mapLanguageToComponentProps())(ModalLinkShare)
